// third-party
import { Box, TableCell, TableRow, Typography, useTheme } from '@mui/material';
import moment from 'moment';

// project import
import ButtonCopy from 'components/Button/ButtonCopy';
import { getColorStatus } from 'constant/transaction';
import useFormatNumber from 'hooks/useFormatNumber';
import { TTransaction } from 'types/wallet';
import { Link } from 'react-router-dom';
import { statusTransaction } from 'constant/status';

// Interface
interface IRowTransactionProps {
    transaction: TTransaction;
}

// ==============================|| RowTransaction ||============================== //

const RowTransaction = (props: IRowTransactionProps) => {
    const { transaction } = props;
    const { fCrypto } = useFormatNumber();
    const theme = useTheme();
    return (
        <TableRow sx={{ width: '100%' }}>
            <TableCell component="td" scope="col" sx={{ width: '15%' }}>
                <Typography variant="h5">{moment(transaction?.created_at).format('DD/MM/YYYY, h:mm')}</Typography>
            </TableCell>
            <TableCell component="td" scope="col" sx={{ textTransform: 'capitalize', width: '15%' }}>
                <Typography variant="h5">{transaction?.type}</Typography>
            </TableCell>

            <TableCell component="td" scope="col" sx={{ width: '15%' }} size="medium">
                <Box sx={{ display: 'flex', alignItems: 'center', gap: 2 }}>
                    <Typography variant="h5">{transaction?.token_short_name}</Typography>
                    <img
                        src={`https://s3.ap-southeast-1.amazonaws.com/tvn.payme/images/coins/${transaction?.token_short_name}.png`}
                        width="20"
                        height="20"
                        alt={transaction?.token_short_name}
                    />
                </Box>
            </TableCell>
            <TableCell component="td" scope="col" sx={{ width: '15%' }}>
                <Typography variant="h5">{fCrypto(transaction?.amount)}</Typography>
            </TableCell>
            <TableCell component="td" scope="col" sx={{ width: '15%' }}>
                <Box sx={{ display: 'flex', alignItem: 'center', gap: 2 }}>
                    <TypoTxId value={transaction?.to} />
                    <ButtonCopy text={transaction?.to} />
                </Box>
            </TableCell>
            <TableCell component="td" scope="col" sx={{ width: '15%' }}>
                <Box sx={{ display: 'flex', alignItem: 'center', gap: 2 }}>
                    {transaction?.status !== statusTransaction.FAILED ? (
                        <Link
                            to={`/tx/${transaction?.txid}`}
                            style={{
                                whiteSpace: 'nowrap',
                                width: '80px',
                                overflow: 'hidden',
                                textOverflow: 'ellipsis',
                                display: 'block',
                                textDecoration: 'none',
                                color: theme.palette.primary.main
                            }}
                        >
                            {transaction?.txid}
                        </Link>
                    ) : (
                        <TypoTxId value={transaction?.txid} />
                    )}

                    <ButtonCopy text={transaction?.txid} />
                </Box>
            </TableCell>
            <TableCell component="td" scope="col" sx={{ textTransform: 'capitalize', width: '10%' }}>
                <Typography variant="h5" sx={{ color: getColorStatus(transaction?.status, theme) }}>
                    {transaction?.status}
                </Typography>
            </TableCell>
        </TableRow>
    );
};

const TypoTxId = ({ value }: { value: string }) => {
    return (
        <Typography
            sx={{
                whiteSpace: 'nowrap',
                width: '80px',
                overflow: 'hidden',
                textOverflow: 'ellipsis',
                display: 'inline-block'
            }}
            variant="h5"
        >
            {value}
        </Typography>
    );
};

export default RowTransaction;
